<template>
    <div :class="{ 'overlay': isLoading }">
        <div class="add_asset">
            <div class="d-flex align-items-center justify-content-between mb-3">
                <h5 style="font-weight: 700; margin: 0;">Tạo tài sản mới</h5>
                <button class="draft" @click="$router.push('/admin/draft-asset')">Bản nháp đã lưu</button>
            </div>
            <b-form class="form-add" @submit="addAsset('add')" @submit.prevent="submitForm">
                <b-row>
                    <b-col cols="lg-7">
                        <h5>Thông tin chi tiết tài sản</h5>
                        <b-row style="align-items: center;">
                            <b-col cols="lg-4">
                                <label for="asset_name">Tên tài sản:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="asset_name" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Nhập tên, mô tả tài sản" v-model="dataAdd.asset_name"
                                    @input="formatTxt('asset_name')" ></b-form-input>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="price">Giá khởi điểm:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <input id="price" class="mb-2 mr-sm-2 mb-sm-0 form-control" placeholder="Nhập số tiền"
                                    v-model="dataAdd.price" maxlength="15" @input="formatInput('price')" >
                            </b-col>

                            <!-- <b-col cols="lg-4">
                                <p>Mã tài sản đấu giá:</p>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <p style="color: #444444; font-weight: 500; margin-bottom: 0;">MTS-HQ6EV3</p>
                            </b-col> -->

                            <b-col cols="lg-4">
                                <label for="time_start_regis">Thời gian bắt đầu đăng ký tham gia đấu giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-row>
                                    <b-col cols="lg-6">
                                        <div>
                                            <b-form-datepicker id="time_start_regis" start-weekday=1 placeholder="Chọn ngày"
                                                locale="vi" v-model="date_start_time_res"></b-form-datepicker>
                                        </div>
                                    </b-col>
                                    <b-col cols="lg-6">
                                        <!-- <b-form-timepicker locale="vi" placeholder="Chọn thời gian" v-model="time_start_time_res"></b-form-timepicker> -->
                                        <b-form-input v-model="time_start_time_res" type="time" locale="vi"
                                            ></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="time_end_regis">Thời gian kết thúc đăng ký:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-row>
                                    <b-col cols="lg-6">
                                        <div>
                                            <b-form-datepicker id="time_end_regis" start-weekday=1 placeholder="Chọn ngày"
                                                locale="vi" v-model="date_end_time_res"></b-form-datepicker>
                                        </div>
                                    </b-col>
                                    <b-col cols="lg-6">
                                        <!-- <b-form-timepicker locale="vi" placeholder="Chọn thời gian" v-model="time_end_time_res"></b-form-timepicker> -->
                                        <b-form-input v-model="time_end_time_res" type="time" locale="vi"
                                            ></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="price_hs">Tiền mua hồ sơ:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <input id="price_hs" class="mb-2 mr-sm-2 mb-sm-0 form-control" placeholder="Nhập số tiền"
                                    v-model="dataAdd.record_fee" maxlength="15" @input="formatInput('record_fee')" >
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="step">Bước giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <input id="step" class="mb-2 mr-sm-2 mb-sm-0 form-control" placeholder="Nhập bước giá"
                                    v-model="dataAdd.step_price" maxlength="15" @input="formatInput('step_price')" >
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="max_step">Số bước giá trả tối đa / lần:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <input id="max_step" class="mb-2 mr-sm-2 mb-sm-0 form-control"
                                    placeholder="Nhập số lần bước giá" v-model="dataAdd.step" maxlength="5"
                                    @input="formatInput('step')" >
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="deposit">Tiền đặt trước:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <input id="deposit" class="mb-2 mr-sm-2 mb-sm-0 form-control"
                                    placeholder="Nhập số tiền đặt trước cho tài sản" v-model="dataAdd.down_payment"
                                    maxlength="15" @input="formatInput('down_payment')" >
                            </b-col>
                            <b-col cols="lg-4">
                            
                            </b-col>
                            <b-col cols="lg-8">
                            
                            <div class="custom-control custom-control-inline custom-checkbox" style="font-size: 20px;font-weight: 500;line-height: 36px;"> 
                                <input type="checkbox" style="width: 20px;height: 20px;" class="custom-control-input" v-model="isShowcntc">  Chủ tài sản là Tổ chức
                            </div>
                            </b-col>
                            <b-col cols="lg-4">
                                <label for="owner_name">Tên chủ tài sản:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="owner_name" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Nhập tên chủ tài sản" v-model="dataAdd.owner" @input="formatTxt('owner')"
                                    ></b-form-input>
                            </b-col>                            
                            <b-col cols="lg-4">
                                <label for="owner_address">Địa chỉ chủ tài sản:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="owner_address" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Nhập địa chỉ chủ tài sản" v-model="dataAdd.owner_address" @input="formatTxt('owner_address')"
                                    ></b-form-input>
                            </b-col>
                            <div  v-if="isShowcntc"> 
                                <b-row style="align-items: center;">
                                <b-col cols="lg-4">
                                    <label for="rep_owner">Người đại diện chủ tài sản:</label>
                                </b-col>
                                <b-col cols="lg-8" class="input-form">
                                    <b-form-input id="rep_owner" class="mb-2 mr-sm-2 mb-sm-0"
                                        placeholder="Nhập người đại diện chủ tài sản"  v-model="dataAdd.rep_owner"  @input="formatTxt('rep_owner')"
                                        ></b-form-input>
                                </b-col>

                                <b-col cols="lg-4">
                                    <label for="owner_position">Chức vụ người đại diện:</label>
                                </b-col>
                                <b-col cols="lg-8" class="input-form">
                                    <b-form-input id="owner_position" class="mb-2 mr-sm-2 mb-sm-0"
                                        placeholder="Nhập chức vụ người đại diện" v-model="dataAdd.owner_position" @input="formatTxt('owner_position')"
                                        ></b-form-input>
                                </b-col>
                                </b-row>
                            </div>
                            <b-col cols="lg-4">
                                <label for="address">Nơi xem tài sản:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="address" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Nhập địa chỉ, nới xem tài sản" v-model="dataAdd.view_address"
                                    @input="formatTxt('view_address')" ></b-form-input>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="time_start">Thời gian bắt đầu trả giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-row>
                                    <b-col cols="lg-6">
                                        <div>
                                            <b-form-datepicker id="time_start" start-weekday=1 placeholder="Chọn ngày"
                                                locale="vi" v-model="date_start_time"></b-form-datepicker>
                                        </div>
                                    </b-col>
                                    <b-col cols="lg-6">
                                        <!-- <b-form-timepicker locale="vi" placeholder="Chọn thời gian" v-model="time_start_time"></b-form-timepicker> -->
                                        <b-form-input v-model="time_start_time" type="time" locale="vi"
                                            ></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="time_end">Thời gian kết thúc trả giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-row>
                                    <b-col cols="lg-6">
                                        <div>
                                            <b-form-datepicker id="time_end" start-weekday=1 placeholder="Chọn ngày"
                                                locale="vi" v-model="date_end_time"></b-form-datepicker>
                                        </div>
                                    </b-col>
                                    <b-col cols="lg-6">
                                        <!-- <b-form-timepicker locale="vi" placeholder="Chọn thời gian" v-model="time_end_time"></b-form-timepicker> -->
                                        <b-form-input v-model="time_end_time" type="time" locale="vi"
                                            ></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="cate">Danh mục tài sản:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-select id="cate" class="form-control form-select" v-model="dataAdd.category_id"
                                    >
                                    <b-form-select-option :value="null">Chọn danh mục</b-form-select-option>
                                    <b-form-select-option v-for="item in listCate" :key="item.category_id"
                                        :value="item.category_id">{{ item.name }}</b-form-select-option>
                                </b-form-select>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="branch">Chi nhánh tổ chức đấu giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-select id="branch" class="form-control form-select" v-model="dataAdd.agency_id"
                                    >
                                    <b-form-select-option :value="null">Chọn chi nhánh tổ chức đấu
                                        giá</b-form-select-option>
                                    <b-form-select-option v-for="item in listAgency" :key="item.agency_id"
                                        :value="item.agency_id">{{ item.agency_name }}</b-form-select-option>
                                </b-form-select>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="contractually">Số hợp đồng đấu giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="contractually" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Số hợp đồng đấu giá" v-model="dataAdd.contractually" @input="formatTxt('contractually')"
                                    ></b-form-input>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="contractually_date">Ngày ký hợp đồng đấu giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-datepicker id="contractually_date" start-weekday=1 placeholder="Chọn ngày"
                                                locale="vi" v-model="dataAdd.contractually_date"></b-form-datepicker>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="contract_annexes">Phụ lục hợp đồng đấu giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="contract_annexes" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Số hợp đồng đấu giá" v-model="dataAdd.contract_annexes" @input="formatTxt('contract_annexes')"
                                    ></b-form-input>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="contract_annexes_date">Ngày ký phụ lục hợp đồng:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-datepicker id="contract_annexes_date" start-weekday=1 placeholder="Chọn ngày"
                                                locale="vi" v-model="dataAdd.contract_annexes_date"></b-form-datepicker>
                            </b-col>
                        </b-row>

                        <h5 style="font-size: 20px; font-weight: 600;">THÔNG BÁO ĐẤU GIÁ</h5>
                        <!-- <b-row>
                            <b-col>
                                <input class="custom-file-input mb-2" type="file" accept="application/pdf" @change="handleFile3Change($event)" >                                 
                                <div v-for="(data, index) in datafile3" :key="'file3-' + index" class="mb-2">
                                    <img src="@/assets/icon/Note.png" alt="">
                                    {{ data.name }}  
                                </div>
                            </b-col>
                        </b-row> -->
                        <ckeditor :editor="editor" v-model="dataAdd.auction_noti" :config="editorConfig" @ready="onReady">
                        </ckeditor>
                    </b-col>
                    <b-col cols="lg-5">
                        <h5>Hình ảnh tài sản:</h5>
                        <!-- <b-row>
                            <b-col cols="lg-3" class="mb-3" v-for="(data, index) in dataImg" :key="index">
                                <img :src="data.result" alt="" style="border-radius: 11px; width: 137px; height: 103px; object-fit: cover;">
                            </b-col>
                        </b-row>
                        <b-form-file class="mt-3 d-none" multiple id="file_img" ref="fileInput" @change="handleImgChange"
                            accept="image/png, image/gif, image/jpeg, image/jpg"></b-form-file>
                        <img src="@/assets/admin/icon/icon_add.png" onclick="$('#file_img').click()"> -->
                        
                        <b-row>
                        <!-- <label class="" for="file-upload" style="line-height: 36px;padding-left: 40px;" ></label> -->
                            <input type="file" id="file-upload" accept="image/png, image/gif, image/jpeg, image/jpg" multiple @change="handleImgChangeMuty">
                            <img src="@/assets/admin/icon/icon_add.png" style="width: 20%;" onclick="$('#file-upload').click()">
                            <div class="image-container">
                                <div v-for="(image, index) in images" :key="index" class="image-item">
                                    <img :src="image.previewUrl" alt="Preview" class="profile-pic" @click="showImage(index)">
                                    <button class="remove-button" @click="removeImage(index)">X</button>
                                </div>
                            </div>
                            <div v-if="showModal" class="modal" @click.self=" closeModal">
                            <div class="modal-content">
                                <span class="close" @click="closeModal">&times;</span>
                                <img :src="selectedImage.previewUrl" alt="Preview" class="modal-image">
                            </div>
                            </div>
                            <!--<button @click="uploadImages">Upload</button>-->
                        </b-row>
                        
						
						<h5>Thông tin tổ chức đấu giá </h5>
                        <b-row>
                            <b-col cols="lg-4">
                                <label for="unit"><img src="@/assets/icon/Company.png" alt=""
                                        style="padding-right: 14px;">Đơn vị tổ chức:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="unit" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Nhập đơn vị tổ chức đấu giá" v-model="dataAdd.org"
                                    @input="formatTxt('org')" ></b-form-input>
                            </b-col>

                            <b-col cols="lg-4">
                                <label><img src="@/assets/icon/Customer.png" alt="" style="padding-right: 14px;">Đấu giá
                                    viên:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-dropdown :text="text_dgv" class="button-list">
                                    <b-dropdown-item v-for="(dgv, index) in listDGV" :key="index"
                                        @click="getNameDGV(dgv.full_name, dgv.user_id)">
                                        <div class="d-flex align-items-center">
                                            <img :src="$storage + dgv.avatar" alt=""
                                                style="width: 45px; height: 45px; border-radius: 31px;"
                                                @error="handleError">
                                            <div class="ml-3">
                                                <p style="font-weight: 500; margin-bottom: 0;">{{ dgv.full_name }}</p>
                                                <p class="m-0">Đấu giá viên - {{ dgv.agency_name }}</p>
                                            </div>
                                        </div>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="add"><img src="@/assets/icon/Location.png" alt=""
                                        style="padding-right: 14px;">Địa điểm:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="add" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Địa điểm tổ chức, trụ sở công ty" v-model="dataAdd.address"
                                    @input="formatTxt('address')" ></b-form-input>
                            </b-col>
                        </b-row>

                        <h5>Tài liệu liên quan</h5>
                       <b-row>
                            <b-col>
                                <input class="custom-file-input mb-2" multiple type="file" @change="handleFileChange($event)" accept="application/pdf" >
                                <div v-for="(data, index) in datafiles" :key="'file1-' + index" class="mb-2">
                                    <img src="@/assets/icon/Note.png" alt="">
                                    {{ data.file.name }}  
                                </div>
                            </b-col>
                        </b-row>

                        <h5 style="margin-top: 28px;">Quy chế đấu giá</h5>
                         <b-row>
                            <b-col>
                                <input class="custom-file-input mb-2" type="file" accept="application/pdf" @change="handleFile2Change($event)" >                                 
                                <div v-for="(data, index) in datafile2" :key="'file2-' + index" class="mb-2">
                                    <img src="@/assets/icon/Note.png" alt="">
                                    {{ data.name }}  
                                </div>
                            </b-col>
                        </b-row>

                        <h5 style="margin-top: 28px;">Số quy chế đấu giá</h5>
                        <b-row>
                            <b-col>
                                <b-form-input id="add" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Số quy chế đấu giá" v-model="dataAdd.statute"
                                    @input="formatTxt('statute')" ></b-form-input>
                            </b-col>
                        </b-row>

                        <h5 style="margin-top: 28px;">Ngày cấp quy chế đấu giá</h5>
                        <b-row>
                            <b-col>
                                <b-form-datepicker start-weekday=1 placeholder="Chọn ngày"
                                            locale="vi" v-model="dataAdd.statute_date"></b-form-datepicker>
                            </b-col>
                        </b-row>

                        <h5 style="margin-top: 28px;">Quy chế riêng</h5>
                        <b-row>
                            <b-col>
                                <b-form-textarea placeholder="Nhập quy chế riêng cho tài sản" rows="5" max-rows="8"
                                    v-model="dataAdd.own_regulation" @input="formatTxt('own_regulation')"
                                    ></b-form-textarea>
                            </b-col>
                        </b-row>

                        <h5 style="margin-top: 18px;">Hồ sơ yêu cầu đăng ký tham gia</h5>
                        <div class="btn-bg" :class="{ 'set-height': dataList.length !== 0 }">
                            <button class="btn-add-req" @click="$refs.listFile.show()" type="button">+ Thêm yêu cầu</button>
                            <p v-for="(data, index) in dataList" :key="index" class="pl-3">{{ data }}</p>
                        </div>

                        <div>
                            <button class="add_asset_btn" type="button" @click="$router.push('/admin/approve-asset')"
                                :disabled="isLoading">Hủy bỏ</button>
                            <button class="add_asset_btn" type="button" @click="addAsset('draft')" :disabled="isLoading">Lưu
                                bản nháp</button>
                            <button class="add_asset_btn add_asset_btn--red" type="submit" :disabled="isLoading">Tạo tài
                                sản</button>
                                {{ isLoading ? 'Đang tạo...' : 'Tạo mới' }}
                        </div>
                    </b-col>
                </b-row>
            </b-form>
            <listFile ref="listFile" @sendDataList="getDataList" />
        </div>
        <div class="loader" v-if="isLoading"></div>
    </div>
</template>
<script>
import listFile from "./modal/list_file.vue";
import Editor from '@ckeditor/ckeditor5-build-decoupled-document';
import '@ckeditor/ckeditor5-build-classic/build/translations/vi';
import axios from 'axios'
export default {
    components: { listFile },
    data() {
        function uploader(editor) {
            editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                return handleImgChangeMuty(loader);
            };
        }

        // function uploadImage(loader) {
        //     return {
        //         upload: () => {
        //             return new Promise((resolve, reject) => {
        //                 loader.file.then(async (file) => {
        //                     try {
        //                         if (!file) return

        //                         var data = {
        //                             'file': file,
        //                             'path': 'asset/image/'
        //                         }

        //                         await axios.post('https://api.daugiadgv.vn/api/common/uploadFile', data, {
        //                             headers: {
        //                                 'x-access-token': '',
        //                                 'Content-Type': 'multipart/form-data'
        //                             }
        //                         }).then(res => {
        //                             const url = 'https://api.daugiadgv.vn/storage/' + res.data.list_result[0].path_tam
        //                             resolve({ default: url })
        //                         })
        //                     } catch (error) {
        //                         reject(error)
        //                     }
        //                 })
        //             })
        //         }
        //     }
        // }
        return {
            text_dgv: 'Tên đấu giá viên',
            date_start_time_res: '',
            time_start_time_res: '',
            date_end_time_res: '',
            time_end_time_res: '',
            date_start_time: '',
            time_start_time: '',
            date_end_time: '',
            time_end_time: '',
            //dataImg: [],
            images: [],
            showModal: false,
            selectedImage: null,
            datafiles: [],
            datafile2: [],
            dataFile: [],                 
            dataList: [],
            token: '',
            listAgency: [],
            listCate: [],
            listDGV: [],
            dataAdd: {
                asset_name: '',
                price: '',
                register_start_time: null,
                register_end_time: null,
                record_fee: '',
                step_price: '',
                step: '',
                down_payment: '',
                owner: '',
                view_address: '',
                start_time: null,
                end_time: null,
                category_id: null,
                agency_id: null,
                auction_noti: '',
                org: '',
                dgv: '',
                address: '',
                regulation: '',
                own_regulation: '',
                datafiles: [],
                files: [],
                datafile2: null,
                required_file: [],
                publish_status: '',
                contractually: '',
                contractually_date: null,
                contract_annexes: '',
                contract_annexes_date: '',
                statute: '',
                statute_date: null,
                owner_address: '',
                rep_owner: '',
                owner_position: '',
                listimages: [],
            },
            number: 0,
            isLoading: false,
            isShowcntc: false,
			assetName: '',
            description: '',   
            editor: Editor,
            editorConfig: {
                extraPlugins: [uploader],
                language: 'vi',
                // mediaEmbed: {
                //     previewsInData: true
                // }
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'strikethrough',
                        'underline',
                        '|',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        '|',
                        'imageUpload',
                        'link',
                        '|',
                        'blockQuote',
                        'insertTable',
                        'alignment',
                        '|',
                        'fontFamily',
                        'fontSize',
                        'fontColor',
                        'fontBackgroundColor',
                    ]
                },
            }
        }
    },
    mounted() {
        const storedData = localStorage.getItem('admInfo')
        if (storedData) {
            var info = JSON.parse(storedData)
            this.token = info.accessToken
        }
        this.getListAgency()
        this.getListCate()
        this.getListDGV()
    },
	 methods: {
        // openFile() {
        //     handleImgChangeMuty(event)
        // },
        //start images upload
        handleImgChangeMuty(event) {
            if (!event?.target?.files) return;
            const files = Array.from(event.target.files);
            const MAX_SIZE = 3 * 1024 * 1024; // 3MB
            if (!files.length) return;           
            files.forEach(file => {
                if (file) {

                     if (file.size > MAX_SIZE) {
                        //alert(`Ảnh "${file.name}" không vượt quá dung lượng 2MB`);
                        this.$toast.error('file ' + file.name + ' không vượt quá dung lượng 3MB!')
                        event.target.value = '';
                        return;
                    }
                    if (!file.type.startsWith('image/')) {
                        alert(`"${file.name}" không phải là ảnh`);return;
                    }
                    const dotIndex = file.name.lastIndexOf('.'); //Tách tên & extension
                    const name = file.name.substring(0, dotIndex);
                    const ext = file.name.substring(dotIndex);
                    let cleanName = name.replace(/^\d+[-_]*/, ''); //Bỏ số ở đầu + dấu -
                    cleanName = cleanName.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').replace(/\s+/g, '-');; // bỏ tiếng việt có dấu
                    const now = new Date();
                    const time = now.getFullYear() +('0' + (now.getMonth() + 1)).slice(-2) +('0' + now.getDate()).slice(-2) +'-' +('0' + now.getHours()).slice(-2) +('0' + now.getMinutes()).slice(-2) +('0' + now.getSeconds()).slice(-2);                    
                    const newFileName = `${cleanName}-${time}${ext}`;// tạo file mới
                    const newFileimage = new File([file], newFileName, {type: file.type});
                    // preview
                    const reader = new FileReader();
                    reader.onload = e => {
                    this.images.push({
                        file: newFileimage,
                        previewUrl: e.target.result
                    });
                    };
                    this.dataAdd.listimages=[];
                    reader.readAsDataURL(newFileimage);
                     // preview
                    // const reader = new FileReader();
                    // reader.onload = e => {
                    // this.images.push({
                    //     file: file,
                    //     previewUrl: e.target.result
                    // });
                    // };
                    // reader.readAsDataURL(file);
                }
               
            });    
        },
        async uploadImages() {        //api      
            if (!this.images.length) {
                //alert('Vui lòng chọn ít nhất 1 ảnh');
                this.$toast.error('Vui lòng chọn ít nhất 1 ảnh')
                return;
            }
            const formData = new FormData();
            //dữ liệu text
            formData.append('asset_name', this.assetName);
            formData.append('description', this.description);
            //ảnh từ RAM
            this.images.forEach(img => {
                formData.append('images', img.file);
            });
            try {
                const res = await this.$axios.post(
                '/common/uploadFileimages',
                formData,
                {
                    headers: {
                    'x-access-token': this.token,
                    'Content-Type': 'multipart/form-data'
                    }
                }
                );
                //console.log('Upload OK:', res.data.list_result);
                // GHI VÀO dataAdd
                this.dataAdd.listimages = res.data.list_result;
                //RETURN CHO addAsset
                return res.data.list_result;

            } catch (err) {
                console.error(err);
                return [];
            }
            // this.$axios.post('/common/uploadFileimages', formData, { })
            // .then(res => {
            //     console.log('Upload OK:', res.data.list_result[0]);
            //     this.dataAdd.listimages.push(res.data.list_result[0]);
            //     return res.data.list_result[0];
            // })
            // .catch(err => {
            //     console.error(err);
            // });
        },        
        removeImage(index) {
            this.images.splice(index, 1);
        },
        showImage(index) {
            this.selectedImage = this.images[index];
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.selectedImage = null;
        },
        //end images upload
        //start file upload
        handleFileChange(event) {
			const files = Array.from(event?.target?.files || []);
			const MAX_SIZE = 10 * 1024 * 1024;
			files.forEach(file => {
				if (file.size > MAX_SIZE) {
					this.$toast.error(`File "${file.name}" không được vượt quá 10MB!`);
					return;
				}
				if (this.datafiles.some(
					x => x.file.name === file.name &&
						 x.file.size === file.size
				)) {
					this.$toast.warning(`File "${file.name}" đã được chọn!`);
					return;
				}
				const renamedFile = this.renameFile(file);
				if (renamedFile) {
					this.datafiles.push({
						file: renamedFile
					});
				}
			});
			event.target.value = '';
		},        
        renameFile(file) {
            //const dotIndex = file.name.replace(/^[\s._-]+/, '');
            const dotIndex = file.name.lastIndexOf('.');
            const name = file.name.substring(0, dotIndex);
            const ext = file.name.substring(dotIndex);
            //let cleanName = name.replace(/^\d+[-_]*/, '');
            let cleanName = name.replace(/^[\d._-]+/, '');
            cleanName = cleanName
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/đ/g, 'd')
                .replace(/Đ/g, 'D')
                .replace(/\s+/g, '-');
            const now = new Date();
            const time =
                now.getFullYear() +
                ('0' + (now.getMonth() + 1)).slice(-2) +
                ('0' + now.getDate()).slice(-2) + '-' +
                ('0' + now.getHours()).slice(-2) +
                ('0' + now.getMinutes()).slice(-2) +
                ('0' + now.getSeconds()).slice(-2);
            const newFileName = `${cleanName}-${time}${ext}`;
            return new File([file], newFileName, { type: file.type });
        },
        handleFile2Change(event,fileType) {
            if (!event?.target?.files) return;
            const file = event.target.files[0];
            if (!file) return;
            const MAX_SIZE = 10 * 1024 * 1024;
            if (file.size > MAX_SIZE) {
                this.$toast.error(
                    `File "${file.name}" không được vượt quá 10MB!`
                );
                event.target.value = '';
                return;
            }
            const renamedFile = this.renameFile(file);
            if (renamedFile) {
                //this.datafile2.push(renamedFile);
                this.datafile2 = [renamedFile];
            }
            event.target.value = '';
        },
        // handleFile3Change(event,fileType) {
        //     if (!event?.target?.files) return;
        //     const file = event.target.files[0];
        //     if (!file) return;
        //     const MAX_SIZE = 10 * 1024 * 1024;
        //     if (file.size > MAX_SIZE) {
        //         this.$toast.error(
        //             `File "${file.name}" không được vượt quá 10MB!`
        //         );
        //         event.target.value = '';
        //         return;
        //     }
        //     const renamedFile = this.renameFile(file);
        //     if (renamedFile) {
        //         //this.datafile2.push(renamedFile);
        //         this.datafile3 = [renamedFile];
        //     }
        //     event.target.value = '';
        // },
        async uploadfileasset(){
            if (!this.datafiles.length &&!this.datafile2.length) {
                return [];
            }            
            const formData = new FormData();
            // Tài liệu
            this.datafiles.forEach(item => {
                if (item?.file) {
                    formData.append('files', item.file);
                }
            });
            // Quy chế
            this.datafile2.forEach(file => {
                if (file) {
                    formData.append('files', file);
                }
            });   
            formData.append('path_moi', 'asset/file/');
            // Kiểm tra trước khi gửi
            // for (const item of formData.entries()) {
            //     console.log('FORMDATA:', item[0], item[1]);
            // }
            // if (this.datafile3[0]) {
            //     formData.append('files', this.datafile3[0]);
            // }
            try {
                const res = await this.$axios.post('/common/uploadFileMunty', formData, {
                    headers: {
                    'x-access-token': this.token,
                    }
                });                
                const result = res.data.list_result || [];
                // Gán type sau khi upload
                let index = 0;
                this.datafiles.forEach(() => {
                    if (result[index]) {
                        result[index].type = 'file';
                    }
                    index++;
                });
                if (this.datafile2[0]) {
                    formData.append('files', this.datafile2[0]);
                }
                return result;
            } catch (err) {
                console.error(err);
                return [];
            }
        },
        // async uploadfileOne(){
        //     if (!this.datafiles3.length) {
        //         return [];
        //     }            
        //     const formData = new FormData();
        //     // Tài liệu mo ta
        //     formData.append('file', this.datafile3[0]);               
        //     formData.append('path_moi', 'asset/file/');
        //     // Kiểm tra trước khi gửi
        //     // for (const item of formData.entries()) {
        //     //     console.log('FORMDATA:', item[0], item[1]);
        //     // }
        //     try {
        //         const res = await this.$axios.post('/common/uploadFileOne', formData, {
        //             headers: {
        //             'x-access-token': this.token,
        //             }
        //         });                
        //         const result = res.data.list_result || [];                
        //         if (this.datafile3[0]) {
        //             formData.append('files', this.datafile3[0]);
        //         }               
        //         return result;
        //     } catch (err) {
        //         console.error(err);
        //         return [];
        //     }
        // },
        getDataList(data) {
            this.dataList = []
            this.dataAdd.required_file = []
            data.forEach(element => {
                this.dataList.push(element.required_file_name)
                this.dataAdd.required_file.push(element.id)
            });
        },
        formatInput(field) {
            if (this.dataAdd[field]) {
                const cleanedValue = this.dataAdd[field].replace(/[^\d]/g, '');
                this.number = parseInt(cleanedValue, 10);
                this.dataAdd[field] = this.number.toLocaleString();
            }
        },        
       
        async getListAgency() {
            const res = await this.$axios.get('/agency/getListAgency', {
                headers: {
                    'x-access-token': this.token
                }
            }).then(res => {
                this.listAgency = res.data
            }).catch(err => {
                if (err.response.status == 409) {
                    localStorage.removeItem('admInfo')
                    this.$toast.error('Tài khoản được đăng nhập từ thiết bị khác!')
                    this.$router.push('/loginAdmin')
                } else if (err.response.status == 401) {
                    localStorage.removeItem('admInfo')
                    this.$toast.error('Phiên đăng nhập đã hết hạn!')
                    this.$router.push('/loginAdmin')
                }
            })
        },
        async getListCate() {
            try {
            const res = await this.$axios.get('/category/getListCategory', {
                params: {
                    code: '',
                    name: '',
                    status: '',
                    parent_id: '',
                    page: '1',
                    per_page: '1000',
                },
                headers: {
                    'x-access-token': this.token
                }
            })
            if (res.status == 200) {
                this.listCate = res.data.result
            }
            } catch (err) {
                console.error(
                    'getListCate:',
                    err.response?.data || err.message
                );
            }
        },
        async getListDGV() {
            const res = await this.$axios.get('/auth/getListUser', {
                params: {
                    user_name: '',
                    user_code: '',
                    role_id: '3',
                    agency_id: '',
                    phone: '',
                    address: '',
                    email: '',
                    full_name: '',
                    gender: '',
                    birthday: '',
                    soTheDGV: '',
                    cccd: '',
                    page: '1',
                    per_page: '10000',
                },
                headers: {
                    'x-access-token': this.token
                }
            })
            if (res.status == 200) {
                this.listDGV = res.data.result
            }
        },
        getNameDGV(name, id) {
            this.text_dgv = name
            this.dataAdd.dgv = id
        },
        async addAsset(type) {
            event.preventDefault()
            if (this.date_start_time_res && this.date_start_time_res) {
                this.dataAdd.register_start_time = this.date_start_time_res + " " + this.time_start_time_res
            }
            if (this.date_end_time_res && this.time_end_time_res) {
                this.dataAdd.register_end_time = this.date_end_time_res + " " + this.time_end_time_res
            }
            if (this.date_start_time && this.time_start_time) {
                this.dataAdd.start_time = this.date_start_time + " " + this.time_start_time
            }
            if (this.date_end_time && this.time_end_time) {
                this.dataAdd.end_time = this.date_end_time + " " + this.time_end_time
            }
            this.dataAdd.price = this.dataAdd.price.replace(/[^\d]/g, '')
            this.dataAdd.record_fee = this.dataAdd.record_fee.replace(/[^\d]/g, '')
            this.dataAdd.step_price = this.dataAdd.step_price.replace(/[^\d]/g, '')
            this.dataAdd.step = this.dataAdd.step.replace(/[^\d]/g, '')
            this.dataAdd.down_payment = this.dataAdd.down_payment.replace(/[^\d]/g, '')
            try {               
                const images = await this.uploadImages();
                this.dataAdd.listimages = images;
                //console.log('upload xong'); 
                //console.log('SUBMIT 1');
                const uploadedFiles = await this.uploadfileasset();
                //console.log('SUBMIT 2:', uploadedFiles);
                this.dataAdd.files = uploadedFiles; 
                //this.dataAdd.files3 = uploadedFiles;                
                //console.log('SUBMIT 3');
                // this.dataAdd.datafiles = result.filter(x => x.type === 'file');
                // this.dataAdd.datafile2 = result.find( x => x.type === 'file2') || null;
                // this.dataAdd.datafiles = result;
                // this.dataAdd.datafile2 = result;
                //   onsole.log('upload file1',this.dataAdd.datafiles);   
                //   onsole.log('upload file2',this.dataAdd.datafile2);                 
                // this.dataAdd.file = resultfile.file || [];
                // this.dataAdd.file2 = resultfile.file2 || [];
                //console.log('upload file xong',this.dataAdd);                
            } catch (e) {
                console.error(e);
            }
            //await this.uploadImages();
            if (type == 'add') {
                if (!this.dataAdd.register_start_time || !this.dataAdd.register_end_time || !this.dataAdd.start_time || !this.dataAdd.end_time || this.dataAdd.listimages.length == 0 || !this.dataAdd.dgv) {
                   // this.$toast.error('Vui lòng nhập đầy đủ thông tin!')
                }else if(this.dataAdd.asset_name.length >250){
                    this.$toast.error('Tiêu đề quá dài vượt quá 250 ký tự!')                
                } else {
                    //
                    this.dataAdd.publish_status = "1"
                    if (this.isLoading) return;
                    this.isLoading = true
                    await this.$axios.post('/asset/createAsset', this.dataAdd, {
                        headers: {
                            'x-access-token': this.token,
                        }
                    }).then(res => {
                        this.$toast.success('Thêm tài sản thành công!')
                        this.$router.push('/admin/approve-asset')
                        this.isLoading = false
                        // clear RAM
                        this.images = [];
                        this.dataAdd.listimages = [];
                        this.selectedImage = null;
                        this.showModal = false;
                        this.dataAdd.datafiles=[];
                        this.dataAdd.files=[];
                    }).catch(err => {
                        this.$toast.error('Thêm tài sản không thành công!')
                        this.isLoading = false
                    })
                    //console.count("SUBMIT");
                }
            } else {
                if(this.dataAdd.asset_name.length >250){
                    this.$toast.error('Tiêu đề quá dài vượt quá 250 ký tự!')   
                }else{
                    this.dataAdd.publish_status = "0"
                    this.isLoading = true
                    await this.$axios.post('/asset/createAsset', this.dataAdd, {
                        headers: {
                            'x-access-token': this.token,
                        }
                    }).then(res => {
                        this.$toast.success('Lưu bản nháp tài sản thành công!')
                        this.$router.push('/admin/draft-asset')
                        this.isLoading = false
                        // clear RAM
                        this.images = [];
                        this.dataAdd.listimages = [];
                        this.selectedImage = null;
                        this.showModal = false;
                        this.dataAdd.datafiles=[];
                        this.dataAdd.files=[];
                    }).catch(err => {
                        this.$toast.error('Lưu bản nháp tài sản không thành công!')
                        this.isLoading = false
                    })
                }
                
            }
        },
        onReady(editor) {
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formatTxt(item) {
            this.dataAdd[item] = this.dataAdd[item].replace(/[<>\[\]]/g, '')
        }
    },
    watch: {
    isShowcntc(val) {
            if (!val) {            
                this.dataAdd.rep_owner = ''
                this.dataAdd.owner_position = ''
            }
        }
    }
    
}
</script>
<style lang="css" scoped>
.set-height {
    height: fit-content !important;
    padding-bottom: 20px;
}

.add_asset {
    color: #515151;
    font-family: Roboto;
}

.add_asset h5 {
    font-size: 20px;
    font-weight: 500;
    line-height: 36px;
}

.form-add {
    box-shadow: 2px 2px 6px 0px #00000026;
    background-color: #FFFFFF;
    border-radius: 15px;
    padding: 19px 10px 32px 30px;
}

.form-add .col-lg-8 {
    margin-bottom: 15px;
}

.form-add input.form-control,
.form-add .form-select,
.form-add textarea.form-control {
    background-color: #EEEEEE;
    border: none;
    border-radius: 15px;
    padding: 11px 12px;
}

.form-add textarea.form-control {
    overflow-y: auto !important;
}

.form-add input.form-control:focus,
.form-add .form-select:focus,
.form-add textarea.form-control {
    box-shadow: none;
}

.form-add input.form-control::placeholder {
    color: #B4B4B4;
}

.custom-file-input::-webkit-file-upload-button {
    visibility: hidden;
}

.custom-file-input {
    color: #515151;
    margin-left: 100px;
    background: #EEEEEE;
    border-radius: 15px;
    padding: 3px 0;
}

.custom-file-input::before {
    position: absolute;
    left: 10px;
    content: 'Chọn file';
    display: inline-block;
    background: #444444;
    border-radius: 15px;
    padding: 6px 13px;
    outline: none;
    white-space: nowrap;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
}

.add_asset button {
    background: none;
    border: none;
}

.add_asset .add_asset_btn {
    color: #EE3439;
    border: 1px solid #EE3439;
    border-radius: 15px;
    box-shadow: 2px 2px 6px 0px #00000026;
    width: 160px;
    height: 42px;
    border-radius: 20px;
    margin-right: 9px;
    margin-top: 20px;
}

.add_asset .add_asset_btn--red {
    color: #FFFFFF;
    background: #EE3439;
    width: 204px;
    height: 45px;
}

.btn-bg {
    background: #EEEEEE;
    border-radius: 15px;
    height: 105px;
}

.btn-add-req {
    color: #EE3439;
    font-weight: 500;
    padding: 10px 0 10px 15px;
}

.draft {
    color: #EE3439;
    border: 1px solid #EE3439 !important;
    border-radius: 20px;
    font-weight: 500;
    padding: 4px 38px;
}

.button-list {
    width: 100%;
}

@media (max-width: 1280px) {

    .custom-file-input {
        margin-left: 0;
    }
}

@media (max-width: 992px) {
    .add_asset_btn--red {
        margin-top: 0;
    }

    .b-form-datepicker {
        margin-bottom: 20px;
    }
}

@media (max-width: 575px) {
    .add_asset_btn--red {
        margin-top: 30px;
    }
}
</style>

<style>
.form-add button.h-auto {
    opacity: 0;
}

.form-add .no-gutters {
    margin: 0;
}

.form-add .b-calendar-grid-help {
    display: none;
}

.form-add .b-calendar .form-control:focus,
.form-add .b-form-datepicker.form-control.focus,
.form-add .form-control.focus {
    box-shadow: none;
    border: 1px solid #ced4da6e;
}

.form-add .text-truncate {
    padding: 0;
}

.form-add .b-form-datepicker,
.form-add .b-form-timepicker {
    background-color: #EEEEEE;
    border-radius: 12px;
    padding: 2px 12px;
}

.form-add .text-muted {
    color: #B4B4B4 !important;
}

.form-add .button-list .dropdown-toggle {
    justify-content: flex-start;
    background-color: #EEEEEE;
    border-radius: 15px;
    padding: 12.5px 12px;
}
/* image nhiều */
 /* input[type="file"] {
     display: none;
 } */
 #file-upload{
    display: none;
 } 
 .image-container {
     display: flex;
     flex-wrap: wrap;
     margin-top: 20px;
 }
 
 .image-item {
     position: relative;
     margin-right: 10px;
     margin-bottom: 10px;
 }
 
 .profile-pic {
     width: 80px;
     height: 80px;
     object-fit: cover;
     border-radius: 50%;
     cursor: pointer;
 }
 
 .remove-button {
     position: absolute;
     top: 5px;
     right: 5px;
     padding: 5px;
     background-color: #f44336;
     color: white;
     border: none;
     border-radius: 50%;
     cursor: pointer;
     font-weight: bold;
 }
 
 .remove-button:hover {
     background-color: #d32f2f;
 }
 
 .modal {
     display: block;
     position: fixed;
     z-index: 1;
     padding-top: 50px;
     left: 0;
     top: 0;
     width: 100%;
     height: 100%;
     overflow: auto;
     background-color: rgba(0, 0, 0, 0.8);
 }
 
 .modal-content {
     margin: auto;
     display: flex;
     justify-content: center;
     align-items: center;
     
     max-width: 800px;
     height: 80%;
 }
 
 .modal-image {
     width: 100%;
     height: auto;
     object-fit: contain;
 }
 
 .close {
     position: relative;
     top: 20px;
     right: 30px;
     font-size: 35px;
     font-weight: bold;
     color: #f1f1f1;
     cursor: pointer;
 }
 
 .close:hover,
 .close:focus {
     color: #bbb;
     text-decoration: none;
     cursor: pointer;
 }
 .modal-backdrop {
    opacity: 0.5;
    position: absolute;
}
 /* image nhiều */
</style>